var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.029,
    height: 23.899,
    viewBox: "0 0 31.029 23.899",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#3063d5;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.009,20.785H28.761L22.9,13.358a.969.969,0,0,0-1.521,1.2l4.909,6.225H9.012l4.9-6.225a.969.969,0,0,0-1.521-1.2L6.528,20.785H2.909a.969.969,0,1,0,0,1.937H4.352L6.157,33.659A3.874,3.874,0,0,0,9.97,36.889H24.948a3.874,3.874,0,0,0,3.813-3.229l1.795-10.921H32A.969.969,0,0,0,32,20.8Zm-5.15,12.552a1.938,1.938,0,0,1-1.911,1.615H9.971A1.938,1.938,0,0,1,8.06,33.336L6.316,22.728H28.6Z",
    transform: "translate(-1.94 -12.99)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.b3f1c2150414f955bf3c6024964776f5.svg";
export { ForwardRef as ReactComponent };